export const GET_AGREEMENT_DETAILS = 'GET_AGREEMENT_DETAILS';
export const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
export const ASYNC_FETCH = 'ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
export const GET_DATA_SUCCESS_GET_AGREEMENTS = 'GET_DATA_SUCCESS_GET_AGREEMENTS';
export const ERR_OCCURED = 'ERR_OCCURED';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const GET_CART_DETAILS = 'GET_CART_DETAILS';
export const UPDATE_SHOW_CART = 'UPDATE_SHOW_CART';
export const VALIDATE_CART_SUCCESS = 'VALIDATE_CART_SUCCESS';
export const OPEN_TOS_MOBILE = 'OPEN_TOS_MOBILE';
export const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
export const EDIT_PAYMENT_REVIEW_ORDER = 'EDIT_PAYMENT_REVIEW_ORDER';
export const INSTALLATION_TYPE_SELF = 'Self SetUp';
export const INSTALLATION_TYPE_PROF = 'Professional SetUp';
export const ORDER_GET_ENABLED_DEVICES = 'ORDER_GET_ENABLED_DEVICES';
export const ORDER_GET_DATA_SUCCESS = 'ORDER_GET_DATA_SUCCESS';
export const ORDER_GET_ENABLED_DEVICES_SUCCESS = 'ORDER_GET_ENABLED_DEVICES_SUCCESS';
export const ORDER_GET_SEND_SMS = 'ORDER_GET_SEND_SMS';
export const ORDER_FETCH_SMS_DEVICES_SUCCESS = 'ORDER_FETCH_SMS_DEVICES_SUCCESS';
export const ORDER_GET_SEND_SMS_SUCCESS = 'ORDER_GET_SEND_SMS_SUCCESS';
export const ORDER_CODE_VALIDATION = 'ORDER_CODE_VALIDATION';
export const ORDERUPDATE_ADRESS_SUUCESS = 'ORDERUPDATE_ADRESS_SUUCESS';
export const ORDERUPDATE_SHIPPING_ADDRESS = 'ORDERUPDATE_SHIPPING_ADDRESS';
export const ORDERUPDATE_SHIPPING_ADDRESS_SUCCESS = 'ORDERUPDATE_SHIPPING_ADDRESS_SUCCESS';
export const ORDER_GET_ZIP_DETAILS_FROM_API = 'ORDER_GET_ZIP_DETAILS_FROM_API';
export const BANDWIDTH_TYPE = {
  mmWave: 'MMW',
  cBand: 'CBD',
  LTE: 'LTE',
};
export const SHOW_REVIEWORDER_API_ERROR = 'SHOW_REVIEWORDER_API_ERROR';
export const FETCH_SMS_DEVICES_SUCCESS = 'FETCH_SMS_DEVICES_SUCCESS';
export const ORDER_FETCH_SMS_DEVICES_ERROR = 'ORDER_FETCH_SMS_DEVICES_ERROR';
export const PROMOS_RESPONSE_RECEIVED = 'PROMOS_RESPONSE_RECEIVED';
export const CEF_REVIEW_ORDER_ERROR = 'CEF_REVIEW_ORDER_ERROR';
export const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
